import React from 'react';
import { Snackbar, IconButton } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
// eslint-disable-next-line import/named
import Slide, { SlideProps } from '@mui/material/Slide';

interface CustomSnackbarProps {
  open: boolean;
  message: string;
  onClose: () => void;
  isError?: boolean;
}

const TransitionDown = (props: SlideProps) => {
  return <Slide {...props} direction="down" />;
};

const CustomSnackbar: React.FC<CustomSnackbarProps> = ({
  open,
  message,
  onClose,
  isError = false
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={2000}
      onClose={(_, reason) => {
        if (reason !== 'clickaway') {
          onClose();
        }
      }}
      message={message}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      TransitionComponent={TransitionDown}
      sx={{
        '& .MuiSnackbarContent-root': {
          backgroundColor: '#ffffff',
          color: '#000000',
          boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.2)'
        }
      }}
      action={
        <IconButton size="small" aria-label="close" color="inherit" onClick={onClose}>
          {isError ? (
            <ErrorIcon fontSize="small" sx={{ color: 'red' }} />
          ) : (
            <CheckCircleIcon fontSize="small" sx={{ color: 'green' }} />
          )}
        </IconButton>
      }
    />
  );
};

export default CustomSnackbar;
